import React from 'react';
import CompanyData from './CompanyData';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';

const CompanyEdit = React.memo((props) => {
    const { selected, onChangeBlock, block, data } = props;

    return (
        <>
            <div id="filters" className="button-group filter-button-group">
                <button className="filterBtn is-checked">Alle</button>
                {data.default_tags != undefined &&
                    data.default_tags.map((filter) => (
                        <button className="filterBtn">{filter.tagname}</button>
                    ))
                }
            </div>
            <SidebarPortal selected={selected}>
                <CompanyData
                    {...props}
                    data={data}
                    block={block}
                    onChangeBlock={onChangeBlock}
                />
            </SidebarPortal>
        </>
    )
})

export default CompanyEdit;